import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import ReferralListComponent from "@/pages/referral-list/ReferralListComponent/ReferralListComponent";
import useHelpers from "@hooks/useHelpers";
import { api__getReferralList } from "@/apis/refferal/refferal";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
var ReferralList = function ReferralList() {
  var _useState = useState(1),
    page = _useState[0],
    setPage = _useState[1];
  var _useParams = useParams(),
    listType = _useParams.listType,
    orderId = _useParams.id;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useApi = useApi([page, orderId], function () {
      return orderId && api__getReferralList(orderId, listType, page)["catch"](function (err) {
        navigateTo("/?ref=referral_list_404");
      });
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    referralList = _useApi2[2];
  var getNextPage = function getNextPage() {
    setPage(page + 1);
  };
  var getPrePage = function getPrePage() {
    setPage(page - 1);
  };
  var getPageByNumber = function getPageByNumber(pageNum) {
    if (page === +pageNum) return;
    setPage(+pageNum);
  };
  useEffect(function () {
    if (!listType || !orderId) return navigateTo("/tracking-checkout-orders");
    if (listType !== "used" && listType !== "delivered") return navigateTo("/tracking-checkout-orders");
  }, []);
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    hideAppBanner: true,
    disableLoader: true
  }, /*#__PURE__*/React.createElement(ReferralListComponent, {
    listType: listType,
    referralList: referralList.list,
    currentPage: referralList.currentPage,
    pageCount: referralList.pageCount,
    loading: loading,
    orderId: orderId,
    getNextPage: getNextPage,
    getPrePage: getPrePage,
    getPageByNumber: getPageByNumber
  }));
};
export default ReferralList;